import { SvgIconProps } from "@mui/material/SvgIcon";
import CameraIcon from "@mui/icons-material/Camera";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

export const SnapshotIcon: FunctionComponent<SvgIconProps> = observer((props) => {
	return <CameraIcon {...props} />;
});

export default CameraIcon;